import { Component, EventEmitter, Input, Output } from '@angular/core';
import { finalize, map, Observable } from 'rxjs';
import { FISCOModel } from 'src/app/models/FISCOModel';
import { PackingPlanningService } from 'src/app/services/packing-planning/packing-planning.service';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-fisco-table',
  templateUrl: './fisco-table.component.html',
  styleUrl: './fisco-table.component.css'
})
export class FiscoTableComponent {
  @Input() toggle: boolean = false;
  @Output() toggleChange = new EventEmitter<boolean>();
  @Output() selectRow = new EventEmitter<any>();
  data$: Observable<FISCOModel[]> = new Observable()
  faCheck = faCheck
  isLoading: boolean = true;


  todayDate: Date = new Date()
  todayFormattedString: string = this.todayDate.toISOString().slice(0, 10)
  yesterday: Date = new Date(this.todayDate)


  constructor(private packService: PackingPlanningService) {
  }

  ngOnInit() {
    this.loadFiscoTableAlt()
  }

  loadFiscoTableAlt() {
    this.isLoading = true
    this.yesterday.setDate(this.todayDate.getDate() - 1)

    const yesterdayDate = this.yesterday.toISOString().slice(0, 10)

    const obs$ = this.packService.getFiscoData(40, yesterdayDate, this.todayFormattedString)
      .pipe(
        map(data => data.sort((a, b) => a.sequencia - b.sequencia)),
        finalize(() => this.isLoading = false)
      )

    // Atribui o observable ao async pipe
    this.data$ = obs$;

    // Também força a execução imediata (garante que finalize sempre roda)
    obs$.subscribe({
      next: () => { },
      error: (err) => {
        console.error('Erro ao carregar dados Fisco:', err);
      }
    });
  }

  onToggleClick(event: MouseEvent) {
    event.stopPropagation()
    this.toggle = !this.toggle
    this.toggleChange.emit(false);
  }

  onSelectRow(data: FISCOModel, event: MouseEvent) {
    event.stopPropagation();
    this.selectRow.emit(data); //evita a propagação para o overlay do formulário raiz
    this.toggle = !this.toggle
  }
}
